import { request } from './common';

function getBaseURL() {
  return `${window.configs.API_HOST}/api/insurance`;
}

export async function fetchInsuranceClaim(contractId: string): Promise<App.InsuranceClaim> {
  const url = `${getBaseURL()}/claim/${contractId}`;
  const { result } = await request(url);
  return result;
}

export interface PassportCardConsumerDetails {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  dateOfBirth?: string;
  insuredPersons?: Array<{
    firstName: string;
    lastName: string;
    dateOfBirth?: string;
  }>;
}

/**
 * Returns the Passport Card policy-holder + insured persons, including each
 * traveller's date of birth. Unlike XCover, the svc-order insurance item only
 * stores `firstname`/`surname` for Passport Card travellers (no DOB/age), so we
 * fetch it here to prefill traveller ages in the update form.
 */
export async function getPassportCardConsumerDetails(
  subscriptionId: string,
  options?: { signal?: AbortSignal },
): Promise<PassportCardConsumerDetails> {
  const url = `${getBaseURL()}/subscription/${subscriptionId}/passport-card-consumer-details`;
  const { result } = await request(url, { signal: options?.signal });
  return result;
}
